import { render } from "./MarkdownRenderer.vue?vue&type=template&id=7d65f842&ts=true"
import script from "./MarkdownRenderer.vue?vue&type=script&lang=ts"
export * from "./MarkdownRenderer.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__